export enum MoreMagicType {
  CHILD_IMAGE = 'child_image',
  DEDICATION = 'dedication_tab',
  ICONED = 'iconed',
}
